import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Params, RouterLink } from '@angular/router';

@Component({
  selector: 'lib-web-result-action-buttons',
  imports: [CommonModule, NgOptimizedImage, RouterLink],
  templateUrl: './result-action-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultActionButtonsComponent {
  readonly muted = input<boolean>(false);
  readonly complete = input<boolean>(false);
  readonly editQueryParams = input.required<Params>();
  readonly deleteQueryParams = input<Params | undefined>();
}
